import { combineReducers } from 'redux';

import applied from './applied';
import auditorAssets from './auditorAssets';
import selected from './selected';

const filters = combineReducers({
  auditorAssets,
  applied,
  selected,
});

export default filters;
